<template>
  <v-card>
    <v-card-title class="px-6">
      Send Invoices To
    </v-card-title>
    <v-divider> </v-divider>
    <v-card-text class="px-6">
      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col cols="12" class="pb-0">
            <v-text-field
              v-model="billing.sendInvoicesTo"
              label="Billing Contact"
              outlined
              :rules="[$rules.required]"
              maxlength="100"
              required
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" class="pb-0">
            <v-text-field
              v-model="billing.sendInvoicesEmail"
              label="Billing Email"
              outlined
              :rules="[$rules.required, $rules.email]"
              maxlength="100"
              required
            >
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-btn @click="save" :loading="saving">Update</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SendInvoicesToCard",
  data: () => ({
    valid: false,
    saving: false
  }),
  computed: {
    ...mapGetters({ billing: "billing/billing" })
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch("billing/updateInvoiceTo", this.billing)
          .then(() => {
            this.$emit("save");

            this.$root.$snackbarSuccess("Send Invoices To saved");
            this.dialog = false;
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while saving"
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
